/**
 * Embed a Streamate camera ever 5 positions.
 */
import { StreamateCamera } from "components/ads/StreamateCamera";
import { SnapOnly } from "components/utils/SnapOnly";
import { VisibleOnly } from "components/utils/VisibleOnly";

interface IProps {
  position: number;
  tags: string[];
}

export const StreamateCameraDispatcher = ({ position, tags }: IProps) => {
  return (
    <SnapOnly key={`streamate-camera-${position}`}>
      <VisibleOnly className="GifPreview">
        <StreamateCamera tags={tags} />
      </VisibleOnly>
    </SnapOnly>
  );
};
